export default "__VITE_ASSET__CzYdhJYW__"